import React, { useState, useEffect } from "react";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import * as Yup from "yup";
import "./SignIn.css";
import { Link } from "react-router-dom";
import {
  Grid,
  Box,
  Paper,
  TextField,
  Button,
  Typography,
  Container,
  Card,
} from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";

import EmailIcon from "@mui/icons-material/Email";
// import image1 from './image-1.png';

import { ErrorMessage, Field, Form, Formik } from "formik";

// import { useHistory } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { ResetLink } from "./Apihelper/Profile";
import AppToast from '../components/Toast/AppToast';

const validationSchema = Yup.object({
  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),
});

const ForgetPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("info");

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };

  const initialValues = {
    email: "",
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    setSubmitting(false);
    setLoading(true);

    try {
      const redirectUrl = window.location.origin + '/reset-password';
      const res = await ResetLink(values.email, redirectUrl);
      if (res.code === "200" || res.code === 200) {
        setSnackbarMessage("Reset password link sent to your email");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        navigate("/", { state: { showSnackbar: true } });
      } else {
        setSnackbarMessage(res.message);
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    } catch (error) {
      setSnackbarMessage("An error occurred. Please try again.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        height: "100vh",
        width: "100vw",
        margin: 0,
        padding: 0,
        background: "linear-gradient(135deg, #1B4332 0%, #2D6A4F 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "fixed",
        top: 0,
        left: 0,
        overflow: "hidden"
      }}
    >
      <Container maxWidth="sm">
        <Card
          elevation={8}
          sx={{
            padding: "40px",
            borderRadius: "16px",
            backgroundColor: "rgba(255, 255, 255, 0.95)",
            backdropFilter: "blur(10px)",
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
          }}
        >
          <Box textAlign="center" mb={4}>
            <Typography
              variant="h5"
              component="p"
              sx={{
                color: "#1B4332",
                fontWeight: 700,
                marginBottom: "4px",
              }}
            >
              Maa Tara Tarini Multi gym
            </Typography>
            <Typography
              variant="h4"
              component="h1"
              sx={{
                color: "#1B4332",
                fontWeight: 600,
                marginBottom: "8px",
              }}
            >
              Forgot Password?
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "#666",
                maxWidth: "400px",
                margin: "0 auto",
                lineHeight: 1.5,
              }}
            >
              Enter your email address and we'll send you a link to reset your password
            </Typography>
          </Box>

          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ errors, touched }) => (
              <Form>
                <Field
                  as={TextField}
                  name="email"
                  fullWidth
                  label="Email Address"
                  variant="outlined"
                  error={touched.email && Boolean(errors.email)}
                  helperText={touched.email && errors.email}
                  sx={{
                    marginBottom: "24px",
                    "& .MuiOutlinedInput-root": {
                      "&:hover fieldset": {
                        borderColor: "#1B4332",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#1B4332",
                      },
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "#1B4332",
                    },
                  }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                        <EmailIcon sx={{ color: "#1B4332" }} />
                          </InputAdornment>
                        ),
                      }}
                    />

                    <Button
                      type="submit"
                      fullWidth
                      disabled={loading}
                  sx={{
                    background: "linear-gradient(135deg, #1B4332 0%, #2D6A4F 100%)",
                            color: "white",
                    padding: "12px",
                    borderRadius: "8px",
                    fontSize: "1rem",
                    fontWeight: 600,
                    textTransform: "none",
                    boxShadow: "0 4px 12px rgba(26, 35, 126, 0.2)",
                    "&:hover": {
                      background: "linear-gradient(135deg, #2D6A4F 0%, #1B4332 100%)",
                      boxShadow: "0 6px 16px rgba(26, 35, 126, 0.3)",
                      transform: "translateY(-1px)",
                    },
                  }}
                >
                  {loading ? (
                    <CircularProgress size={24} sx={{ color: "white" }} />
                  ) : (
                    "Send Reset Link"
                  )}
                    </Button>

                <Box sx={{ textAlign: "center", marginTop: "24px" }}>
                  <Link
                    to="/"
                    style={{
                      color: "#1B4332",
                      textDecoration: "none",
                      fontWeight: 500,
                      "&:hover": {
                        textDecoration: "underline",
                      },
                    }}
                  >
                    Back to Login
                  </Link>
                </Box>
              </Form>
            )}
          </Formik>
        </Card>
      </Container>

      <AppToast open={snackbarOpen} message={snackbarMessage} severity={snackbarSeverity} onClose={handleSnackbarClose} />
    </Box>
  );
};

export default ForgetPassword;
